import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Typography, Button, Space, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addReward } from '../../ducks/services';
import AddForm from '../components/AddForm';
import { useTranslate } from 'Translate';

const { Title, Text } = Typography;

export default (props) => {
  const navigate = useNavigate();
  const meta = useSelector((state) => state.product.option);
  const [activeTab, setActiveTab] = useState("1");
  const i18n = useTranslate();
  const { t } = i18n;

  return (
    <Row gutter={[10, 10]}>
      <Col span={24}>
        <Row justify={'space-between'} align={'middle'}>
          <Col flex='auto'>
            <Title level={3} className='mb-0 mt-0'>{t("LoyaltyApp.new_reward")}</Title>
          </Col>
          <Col flex='auto' className='text-right'>
            <Space size={10}>
              <Button size="large" htmlType='button' className='red-btn text-white' onClick={() => navigate('/loyalty-app/rewards')}>{'<'} {t("General.back")}</Button>
            </Space>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <AddForm
          loading={props.loading}
          setLoading={props.setLoading}
          meta={meta}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          oneTab={true}
          addReward={addReward}
          navigate={navigate}
          mode={'add'}
          allowedEdit={true}
        />
      </Col>
    </Row>
  )
}